const USECASEIDS = require('../USECASEIDS');

// These UI rules handle the form without a generic write to its namespace/relation.
// This only exempts the inferred form write, not namespace declarations, child actions,
// or API permissions. Keep this list aligned with the corresponding rule registrations.
module.exports = function usesCustomFormAction({ hNodeType, namespace, relation, action, useCaseId }) {
    if (hNodeType !== 'SingleRecordForm') return false;

    // doingCreate_sensor_tag_IT encodes through the native service queue; the AT rule
    // associates a scanned tag with an asset. Neither creates a sensor:tag API record.
    return (
        namespace === 'sensor' &&
        relation === 'tag' &&
        action === 'create' &&
        [USECASEIDS.ITEM_TRACKING, USECASEIDS.WORK_IN_PROCESS, USECASEIDS.RFID, USECASEIDS.ASSET_TRACKING].includes(
            String(useCaseId)
        )
    );
};
